/** Occasion color palette shared with Guest Allocation QR passes. */

export const OCCASION_QR_PALETTE = [
  {
    key: "teal",
    primary: "#008080",
    soft: "#e5f7f7",
    page: "#eef6f6",
    chip: "#d7f1f1",
    bar: "#b8e0e0",
  },
  {
    key: "orange",
    primary: "#d17a1f",
    soft: "#fff4e6",
    page: "#fff8f0",
    chip: "#ffe0bf",
    bar: "#f0c987",
  },
  {
    key: "blue",
    primary: "#1d4fbf",
    soft: "#e8efff",
    page: "#f3f6ff",
    chip: "#c5dbff",
    bar: "#9fb8f0",
  },
  {
    key: "purple",
    primary: "#6b4fcf",
    soft: "#f3edff",
    page: "#f8f5ff",
    chip: "#ddd0f8",
    bar: "#c4b0f0",
  },
  {
    key: "green",
    primary: "#2f8f4e",
    soft: "#e8f6ec",
    page: "#f3faf5",
    chip: "#c8ebcf",
    bar: "#9dcea8",
  },
  {
    key: "rose",
    primary: "#c44d6a",
    soft: "#fdecef",
    page: "#fff5f7",
    chip: "#f7d0d8",
    bar: "#e8a8b6",
  },
  {
    key: "navy",
    primary: "#1f3a5f",
    soft: "#e8eef6",
    page: "#f2f5f9",
    chip: "#cdd9e8",
    bar: "#9aafc7",
  },
  {
    key: "maroon",
    primary: "#8b3a3a",
    soft: "#f8ecec",
    page: "#fbf4f4",
    chip: "#ebcfcf",
    bar: "#d09a9a",
  },
];

export const DEFAULT_QR_THEME = OCCASION_QR_PALETTE[0];

export const getOccasionThemeByIndex = (index = 0) => {
  const len = OCCASION_QR_PALETTE.length;
  const safeIndex = Number.isFinite(index) ? index : 0;
  return OCCASION_QR_PALETTE[((safeIndex % len) + len) % len];
};

export const getOccasionThemeForId = (occasions = [], occasionId = null) => {
  if (occasionId == null || occasionId === "" || occasionId === "all") {
    return DEFAULT_QR_THEME;
  }
  const index = (occasions || []).findIndex(
    (occasion) => String(occasion._id) === String(occasionId)
  );
  return getOccasionThemeByIndex(index >= 0 ? index : 0);
};
